import { render } from "./SubjectRF.vue?vue&type=template&id=ad10d3aa"
import script from "./SubjectRF.vue?vue&type=script&lang=js"
export * from "./SubjectRF.vue?vue&type=script&lang=js"

import exportComponent from "/builds/vei/portal/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__